export function useSystemType(): 'vl-app' | 'vl-admin' {
  return 'vl-admin';
}

export default useSystemType;
